/* MK Microsite — cart + interactions. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  // אם הקובץ נטען יותר מפעם אחת — לא מריצים אותו שוב
  if (window.mkMicrosite) return;

  var routes = (window.mkRoutes || {});
  var strings = (window.mkStrings || {});

  function money(cents) {
    if (window.mkMoneyFormat) {
      return window.mkMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }
    return (cents / 100).toFixed(2);
  }

  /* ---------------- toast ---------------- */

  var toastEl, toastTimer;
  function toast(message, linkHtml) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mk-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + message + '</span>' + (linkHtml || '');
    requestAnimationFrame(function () { toastEl.setAttribute('data-open', 'true'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-open', 'false'); }, 4200);
  }

  /* ---------------- cart ---------------- */

  function refreshCount() {
    fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mk-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function addToCart(id, quantity, button) {
    if (button) { button.disabled = true; button.dataset.mkLabel = button.textContent; button.textContent = strings.adding || 'מוסיף…'; }
    return fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'error');
        refreshCount();
        toast(
          strings.added || 'נוסף לסל',
          '<a href="' + (routes.cartPage || '/cart') + '">' + (strings.viewCart || 'לסל הקניות') + '</a>'
        );
        return res.data;
      })
      .catch(function (err) {
        toast(err.message || strings.error || 'לא ניתן להוסיף לסל');
      })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.mkLabel || button.textContent; }
      });
  }

  function changeLine(key, quantity, scope) {
    if (scope) scope.classList.add('mk-loading');
    fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (scope) scope.classList.remove('mk-loading');
        toast(strings.error || 'משהו השתבש');
      });
  }

  /* ---------------- delegated events ---------------- */

  document.addEventListener('click', function (event) {
    var quick = event.target.closest('[data-mk-add]');
    if (quick) {
      event.preventDefault();
      addToCart(quick.getAttribute('data-mk-add'), 1, quick);
      return;
    }

    var step = event.target.closest('[data-mk-step]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('[data-mk-qty]');
      var input = wrap.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = parseInt(input.value || '1', 10) + parseInt(step.getAttribute('data-mk-step'), 10);
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = event.target.closest('[data-mk-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-mk-remove'), 0, remove.closest('.mk-line'));
      return;
    }

    var burger = event.target.closest('[data-mk-burger]');
    if (burger) {
      var nav = document.querySelector('[data-mk-mobile-nav]');
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', open ? 'false' : 'true');
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }

    var thumb = event.target.closest('[data-mk-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-mk-gallery]');
      var main = gallery.querySelector('[data-mk-gallery-main] img');
      var src = thumb.getAttribute('data-mk-thumb');
      if (main && src) {
        main.src = src;
        main.srcset = '';
        gallery.querySelectorAll('[data-mk-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      }
    }
  });

  document.addEventListener('change', function (event) {
    var lineInput = event.target.closest('[data-mk-line-qty]');
    if (lineInput) {
      changeLine(lineInput.getAttribute('data-mk-line-qty'), parseInt(lineInput.value || '1', 10), lineInput.closest('.mk-line'));
    }
  });

  /* ---------------- product form ---------------- */

  function initProductForm(form) {
    var data = form.querySelector('[data-mk-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idField = form.querySelector('[data-mk-variant-id]');
    var priceEl = form.querySelector('[data-mk-price]');
    var wasEl = form.querySelector('[data-mk-was]');
    var submit = form.querySelector('[data-mk-submit]');
    var soldOut = strings.soldOut || 'אזל מהמלאי';
    var addLabel = strings.addToCart || 'הוספה לסל';

    var optionInputs = form.querySelectorAll('[data-mk-option]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-mk-option]:checked'), function (i) { return i.value; });
    }

    function match(values) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }

    function update() {
      var variant;

      if (!optionInputs.length || variants.length === 1) {
        // מוצר עם וריאנט אחד בלבד — אין מה להתאים
        variant = variants[0];
      } else {
        var values = selected();
        variant = match(values);

        // סימון ערכים שאין להם צירוף זמין (בלי לנעול את הבחירה הנוכחית)
        Array.prototype.forEach.call(optionInputs, function (input) {
          if (input.checked) { input.disabled = false; return; }
          var index = parseInt(input.getAttribute('data-mk-option'), 10);
          var test = values.slice();
          test[index] = input.value;
          input.disabled = !variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
        });
      }

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = strings.unavailable || 'הצירוף אינו זמין'; }
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (wasEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wasEl.textContent = onSale ? money(variant.compare_at_price) : '';
        wasEl.hidden = !onSale;
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? addLabel : soldOut;
      }

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-mk-option]')) update();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qtyInput = form.querySelector('[data-mk-qty] input');
      var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      addToCart(idField.value, qty, submit);
    });

    update();
  }

  /* ---------------- reveal on scroll ---------------- */

  function initReveal() {
    var items = document.querySelectorAll('[data-mk-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mk-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- marquee duplication ---------------- */

  function initMarquee() {
    document.querySelectorAll('[data-mk-marquee]').forEach(function (track) {
      if (track.dataset.mkCloned) return;
      track.innerHTML += track.innerHTML;
      track.dataset.mkCloned = 'true';
    });
  }

  function init() {
    document.querySelectorAll('[data-mk-product-form]').forEach(initProductForm);
    initReveal();
    initMarquee();
    refreshCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the Shopify theme editor when a section is re-rendered
  document.addEventListener('shopify:section:load', init);

  window.mkMicrosite = { addToCart: addToCart, toast: toast, refreshCount: refreshCount };
})();